module.exports = ".revenue-infos {\n  font-size: 1.2rem; }\n  .revenue-infos .badge {\n    font-family: Arial, Helvetica, sans-serif;\n    padding: 8px 10px; }\n  .potencial-receita h5 {\n  margin-bottom: 15px;\n  color: #0275d8; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/summary/summary.component.scss
// module id = ./src/app/limit-flow-proposal/component/summary/summary.component.scss
// module chunks = main